import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import AxiosCustom from "common/components/apiConfig";
import {
  handleNotificationAlertCatch,
  handleNotificationAlertTrySelect,
} from "common/method/handleNotificationAlert";

// import { handleNotificationAlertTrySelect } from './../../common/method/handleNotificationAlert/index';

export const actionTypes = {
  userSelectMarketerFinancialFull: "userSelectMarketerFinancialFull [Action]",
  userSelectMarketerFinancialFullLoading:
    "userSelectMarketerFinancialFullLoading [Action]",
  userSelectMarketerFinancialFullAsync:
    "userSelectMarketerFinancialFullAsync [Action]",
};
const inistiaState = {
  data: [],
  loading: false,
  total: 0,
};

export const user_select_marketer_financial_full_Reducer = (
  state = inistiaState,
  { type, payload }
) => {
  switch (type) {
    case actionTypes.userSelectMarketerFinancialFull:
      return {
        ...state,
        data: payload?.results,
        total: payload?.total,
      };
    case actionTypes.userSelectMarketerFinancialFullLoading:
      return {
        ...state,
        loading: payload,
      };
    default:
      return state;
  }
};

function* handleWorker({ payload }) {
  yield put({
    type: actionTypes.userSelectMarketerFinancialFullLoading,
    payload: true,
  });

  let config = {
    url: "select_request",
  };

  let data = {
    table: "marketer",
    method_type: "user_select_marketer_financial_full",
    data: payload?.data ? payload.data : {},
    size: 10,
    from_: 0,
  };

  try {
    let res = yield AxiosCustom(config, data);
    let isOk = handleNotificationAlertTrySelect(res);
    if (!isOk) {
      return;
    }
    yield put({
      type: actionTypes.userSelectMarketerFinancialFull,
      payload: res?.data?.response?.data,
    });
  } catch {
    handleNotificationAlertCatch();
  } finally {
    yield put({
      type: actionTypes.userSelectMarketerFinancialFullLoading,
      payload: false,
    });
  }
}

export function* userSelectMarketerFinancialFull() {
  yield takeLatest(
    actionTypes.userSelectMarketerFinancialFullAsync,
    handleWorker
  );
}
